<div class="property-abstract" [style.background-color]="highlighted()?'#f0f0f0':''" (click)="onPropertyClick()">
  @let pa=propertyAbstract();
  <div class="abstract-row flex-row">
    <div class="image-cell">
      <div [style.background-color]="pa.dashboardMarkerColor" class="status-marker"></div>
      @if (pa.imageReference) {
        <img [src]="pa.imageReference" class="property-image">
      }
      @else {
        <img src="assets/images/others/no_image.jpg" class="property-image">
      }
    </div>
    <div class="abstract-sections flex-row w-100">
      <div class="image-gap abstract-section abstract-status flex-col justify-center">
        @if(isAuction){
          @if (pa.isLive || pa.auctionEnded) {
            <div class="flex-row">
              @if (pa.reserveMet) {
                <span class="green-color text-bold">Reserve Met</span>
              }
              @else if (pa.reserveMetWithCredit) {
                <span class="orange-color text-bold">Reserve Equalized</span>
              }
              @else {
                <span class="red-color text-bold">Reserve Not Met</span>
              }
              <span class="mx-2">|</span>
              <a class="primary-color no-text-decoration" href="javascript:void(0)" (click)="onBidsClick(pa); $event.stopPropagation();">{{pa.displayBidCount}}</a>
            </div>
          }
          @else{
            <a class="primary-color no-text-decoration" href="javascript:void(0)" (click)="onBidsClick(pa); $event.stopPropagation();">Bidding Activity</a>
          }
          @if (pa.currentBid) {
            <div class="text-bold">
              {{ Math.ceil(pa.currentBid) | currency:'USD':'symbol':'1.2-2' }}
              @if (pa.currentBid % 1 !== 0) {
                <span class="text-muted">({{ pa.currentBid | currency:'USD':'symbol':'1.2-2' }})</span>
              }
            </div>
          }
          @else if (pa.reservePrice) {
            <div class="text-bold">{{pa.reservePrice | currency:'USD':'symbol':'1.2-2'}} (Reserve)</div>
          }
          @if (pa.auctionEnding && !pa.auctionEnded) {
            <div>Ends: {{pa.auctionEnding | date:'short' }}</div>
          }
          @else {
            <div>Ended: {{pa.auctionEnding | date:'short' }}</div>
          }
        }
        @else if(isMakeOfferBuyNow || isRegularSale || isCallForOffer){
          <div class="text-bold" [class]="pa.isLive?'green-color':''">Listing @if (!pa.isLive){<span>Not</span>} Live</div>
          @if (pa.showSaleStatus) {
            <div class="orange-color text-bold">{{pa.saleStatusLabel}}</div>
          }
          @if (isCallForOffer) {
            @if (pa.auctionEnding && !pa.auctionEnded) {
              <div>Ends: {{pa.auctionEnding | date:'short' }}</div>
            }
            @else if (pa.auctionEnded) {
              <div>Ended: {{pa.auctionEnding | date:'short' }}</div>
            }
          }
        }
      </div>
      <div class="phase-cell flex-col items-center mt-3 mr-3">
        @if(canEditProperties){
          <button class="phase-button" [style.background-color]="propertyPhase.color" [matMenuTriggerFor]="phaseMenu" (click)="$event.stopPropagation();"><span class="check-mark">✓</span></button>
        }
        @else{
          <button class="phase-button" [style.background-color]="propertyPhase.color" disabled><span class="check-mark">✓</span></button>
        }
        <mat-menu #phaseMenu="matMenu">
            @for(phase of propertyPhases; track phase){
            <button
                mat-menu-item
                (click)="onSelectPropertyPhase(phase);">
                <mat-icon [style.color]="phase.color">check</mat-icon>
                <span>{{phase.name}}</span>
            </button>
            }
        </mat-menu>
      </div>
      <mat-divider [vertical]="true" class="abstract-divider abstract-divider-first my-2"></mat-divider>
      <!-- forces address + client into a new row on narrow screens (see scss) -->
      <div class="abstract-break"></div>
      <div class="abstract-gap abstract-section abstract-address flex-col justify-center">
        @if(pa.address.hasAddress){
          <div class="flex-row space-between items-center w-100">
            <div class="text-md">{{pa.address.streetAddress1}}</div>
            <a mat-icon-button (click)="onAddressCopyClick(); $event.stopPropagation();" matTooltip="Copy address to Clipboard"><mat-icon class="primary-color">content_copy</mat-icon></a>
          </div>
          <div class="text-sm">{{pa.address.city}}, {{pa.address.state}} {{pa.address.zipCode}}</div>
        }
        @else{<div class="text-md">{{pa.header}}</div>}
        <div class="flex-row primary-color items-center space-between">
          <a class="primary-color no-text-decoration" [routerLink]="disabled()?null:'/properties/'+pa.id">ID: {{pa.propertyId}}</a>
        </div>
      </div>
      <mat-divider [vertical]="true" class="abstract-divider my-2"></mat-divider>
      <div class="abstract-gap abstract-section abstract-client flex-col justify-start">
        <div class="flex-row space-between items-center">
          @if(!isClient && pa.clientObject){
            <div class="primary-color text-bold">{{pa.clientObject.name}}</div>
          }
          @else {<div class="text-sm">{{pa.saleTypeObject?.name}}</div>}
          @if(pa.portfolioId){
            <div class="portfolio" (click)="onPortfolioClick($event); $event.stopPropagation(); ">Portfolio ({{pa.portfolioPropertyCount}})</div>
          }
        </div>
        @if(pa.clientObject){
          <div class="text-sm">{{pa.saleTypeObject?.name}}</div>
          @if(!isClient){
            <div class="flex-col">
              @for(assetManagerId of pa.assetManagerIds?.slice(0, 2); track $index){
                @let cc=pa.clientObject.getClientContact(assetManagerId);
                @if(cc) {
                  <div class="primary-color contact">{{cc.firstName}} {{cc.lastName}} ({{cc.email}}) @if($index == 1 && pa.assetManagerIds?.length && pa.assetManagerIds.length>2){<span class="ml-2">...</span>}</div>
                }
              }
            </div>
          }
        }
      </div>
    </div>
  </div>
</div>